module.exports = __webpack_public_path__ + "img/711.a4721382.png";